import { notification as antdNotification } from 'antd';
import type { ArgsProps } from 'antd/es/notification/interface';

type NotificationType = 'success' | 'error' | 'warning' | 'info';

export interface INotification extends Omit<ArgsProps, 'type'> {
  type?: NotificationType;
}

const withDefaults = (props: ArgsProps): ArgsProps => ({
  placement: props.placement ?? 'topRight',
  duration: props.duration ?? 3,
  ...props,
});

const isNotificationType = (value: string | undefined): value is NotificationType =>
  value === 'success' || value === 'error' || value === 'warning' || value === 'info';

export const useNotification = () => {
  const [notificationApi, contextHolder] = antdNotification.useNotification();

  const openNotification = ({ type = 'info', ...props }: INotification) => {
    notificationApi.open(
      withDefaults({
        ...props,
        type: isNotificationType(type) ? type : 'info',
      })
    );
  };

  const closeNotification = () => notificationApi.destroy();

  return {
    contextHolder,
    openNotification,
    closeNotification,
    open: (props: ArgsProps) => notificationApi.open(withDefaults(props)),
    success: (props: ArgsProps) => notificationApi.success(withDefaults(props)),
    error: (props: ArgsProps) => notificationApi.error(withDefaults(props)),
    warning: (props: ArgsProps) => notificationApi.warning(withDefaults(props)),
    info: (props: ArgsProps) => notificationApi.info(withDefaults(props)),
    destroy: closeNotification,
  };
};
